import axios from "axios";

let _apiAxios;
export const initApiAxios = (config) => {
  const { api: baseURL } = config;
  _apiAxios = axios.create({ baseURL });
};
export const useAxios = () => {
  if (_apiAxios == null) {
    throw Error("Api-Axios is not initialized yet. Call 'initApiAxios(config)' first.");
  }
  return _apiAxios;
};

export const download = async (url, method = "GET", filename = null, type = null) => {
  const response = await _apiAxios({ url, method, responseType: "blob" });

  if (!filename) {
    // try to get filename from content-disposition header
    const disposition = response.headers["content-disposition"];
    if (disposition && disposition.indexOf("attachment") !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }
    }
  }

  if (!type) {
    type = response.headers["content-type"];
  }

  const blob = new Blob([response.data], { type });
  if (filename) {
    blob.name = filename;
  }
  return blob;
};
